// Config panel for the "log_message" action block
import React from 'react';
import {
  Box,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  Alert
} from '@mui/material';

const LogMessageConfig = ({ config, onChange, onSummaryChange }) => {
  const handleChange = (field, value) => {
    const updated = { ...config, [field]: value };
    onChange(updated);
    const msg = updated.message || '';
    onSummaryChange(msg.length > 30 ? msg.slice(0, 30) + '...' : msg || 'No message');
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Typography variant="caption" color="text.secondary">
        Adds a message to the execution log. Useful for debugging flows.
      </Typography>

      <TextField
        size="small"
        label="Message"
        value={config.message || ''}
        onChange={(e) => handleChange('message', e.target.value)}
        multiline
        rows={3}
        required
        helperText={'Use {{variableName}} to insert variable values'}
      />

      <Alert severity="info" variant="outlined" sx={{ py: 0.5, '& .MuiAlert-message': { fontSize: '0.7rem' } }}>
        <strong>Variable syntax:</strong> <code>{'{{varName}}'}</code><br />
        Example: <code>{'SIP call from {{sip}} at location {{locationId}}'}</code>
      </Alert>

      <FormControl fullWidth size="small">
        <InputLabel>Level</InputLabel>
        <Select
          value={config.level || 'info'}
          onChange={(e) => handleChange('level', e.target.value)}
          label="Level"
        >
          <MenuItem value="info">Info</MenuItem>
          <MenuItem value="warning">Warning</MenuItem>
        </Select>
      </FormControl>
    </Box>
  );
};

export default LogMessageConfig;
